import moment from "moment";

interface JourneyDetails {
    journeyKey: string;
  }
  
interface JourneyItem {
  journeyDetails: JourneyDetails;
  data: Data;
}
interface CheckinByJourneyRequirements {
    restrictions: string[];
}  

interface Data {
    checkinByJourneyRequirements: CheckinByJourneyRequirements;
  }
 
export default function hasNotOpenedRestriction(ele: JourneyItem): boolean {
  if (ele?.arrival && moment().isAfter(moment(ele.arrival)) && !ele.isAnyCheckedIn) {
    return true;
  }
  return false;
}